import { render } from "./Testing2.vue?vue&type=template&id=bc108d50"
import script from "./Testing2.vue?vue&type=script&lang=js"
export * from "./Testing2.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__